module.exports = __webpack_public_path__ + "assets/img/2023_3.0aa0dc10.png";